import { GamificationNotification } from '../types';

/**
 * The "big" notifications that earn a full-screen celebratory modal moment
 * (level-up, streak milestone, gold/platinum badge). Everything else stays a
 * quiet bottom-right toast. Both GamificationMoment and GamificationToast read
 * this single predicate so a notification is never shown twice.
 */
export function isGamificationMoment(n: GamificationNotification): boolean {
  if (n.type === 'level_up') return true;
  if (n.type === 'streak_milestone') return true;
  if (n.type === 'badge_earned') return n.badge?.tier === 'gold' || n.badge?.tier === 'platinum';
  return false;
}
